var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ErrorMessage'),_c('ConfiguratorHeader'),_c('div',{staticClass:"configurator__grid"},[_c('SelectorConnector',{attrs:{"parameter":'connector_left'}}),_c('SelectorCable',{attrs:{"parameter":'cable'}}),_c('SelectorConnector',{attrs:{"parameter":'connector_right'}})],1),_c('ConfiguratorFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }